// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../next/Next.bs.js");
let DialogV5 = require("../../../v5/common/Components/DialogV5.bs.js");
let ButtonsV5 = require("../../../v5/common/Components/ButtonsV5.bs.js");
let EventLogs = require("../../EventLogs.bs.js");
let ViewStack = require("../ViewStack.bs.js");
let AuthSession = require("../../../utils/AuthSession.bs.js");
let UserSession = require("../UserSession/UserSession.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function TerminatedAccountOverlay$ForceActivateDialog(props) {
  let logout = props.logout;
  return JsxRuntime.jsxs(DialogV5.make, {
    title: "Your Subscription is Inactive",
    isOpen: true,
    ariaLabel: "Your subscription is inactive",
    onDismiss: prim => {},
    showCloseButton: false,
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          "You no longer have an active TAN subscription. Please go to your billing settings if you wish to reactivate it.",
          JsxRuntime.jsx("br", {}),
          JsxRuntime.jsx("br", {}),
          "If you have another account that is active you can log out and use that one instead."
        ],
        className: "leading-normal"
      }),
      JsxRuntime.jsx("div", {
        className: "mt-[16px]"
      }),
      JsxRuntime.jsxs(ViewStack.make, {
        justifyContent: "flexEnd",
        flexDirection: "row",
        children: [
          JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            onClick: param => logout(),
            children: "Log Out"
          }),
          JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
            href: "/subscribe",
            children: "Reactivate Your Account"
          })
        ]
      })
    ]
  });
}

let ForceActivateDialog = {
  make: TerminatedAccountOverlay$ForceActivateDialog
};

function TerminatedAccountOverlay(props) {
  let router = Next.useRouter();
  let pathname = Next.Router.pathname(router);
  let recordEvent = EventLogs.useRecordEventByCurrentUser();
  let logout = () => {
    recordEvent(undefined, "Logout", undefined);
    AuthSession.logout();
  };
  let isOnAccountSettingsPage = Next.Router.asPath(router).startsWith("/account/billing");
  let isPageAllowed = isOnAccountSettingsPage || pathname === "/subscribe";
  let agent = UserSession.useAgentInfo();
  let tmp = agent.membership.account.accountStatus;
  if ((tmp === "ACTIVE" || tmp === "TERMINATED") && !(tmp === "ACTIVE" || isPageAllowed)) {
    return JsxRuntime.jsx(TerminatedAccountOverlay$ForceActivateDialog, {
      logout: () => logout()
    });
  } else {
    return null;
  }
}

let make = TerminatedAccountOverlay;

let $$default = TerminatedAccountOverlay;

exports.ForceActivateDialog = ForceActivateDialog;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* Next Not a pure module */
